import Immutable, { fromJS } from 'immutable';
import pick from 'lodash/pick';
import BibConstants from 'app/constants/BibConstants';

const initialState = Immutable.fromJS({
  isLoaded: false,
  isFetching: false,
  staffComments: {
    results: []
  },
  communityComments: {
    results: []
  },
  quotations: {
    results: []
  },
  tags: {
    summaries: []
  },
  summaries: {
    results: []
  },
  videos: {
    results: []
  },
  ageSuitabilities: {
    results: []
  },
  summary: null,
  commentSummary: null
});

export default function ugcReducer(state = initialState, action) {
  switch (action.type) {
    case BibConstants.FETCH_UGC_FAILURE:
      return initialState;

    case BibConstants.FETCH_UGC_REQUEST: {
      return state.merge({
        isFetching: true
      });
    }

    case BibConstants.FETCH_UGC_SUCCESS: {
      const picked = pick(action.payload.ugc, [
        'summary',
        'commentSummary',
        'staffComments',
        'communityComments',
        'ratings',
        'quotations',
        'summaries',
        'videos',
        'ageSuitabilities',
        'tags',
        'flags',
        'likes'
      ]);
      // The gateway omits commentSummary when there is none (CORE-78370), so null it explicitly —
      // merge would otherwise carry the previous bib's summary across a client-side navigation.
      return state.merge(fromJS({ ...picked, commentSummary: picked.commentSummary ?? null }), {
        isLoaded: true,
        isFetching: false
      });
    }

    default:
      return state;
  }
}
